import React from 'react'
import Popover from 'components/Popover/Popover'
import { MathComponent } from 'mathjax-react'

const textAsReactComponent = text => {
  const miliseconds = new Date().getMilliseconds()
  let htmlId = 'text-as-component-' + miliseconds
  let cssClass = 'text-as-component'
  if (text.includes('data-toggle="popover"')) {
    text = text.replace('<strong><a class="popup-text"', '<a class="popup-text"')
    text = text.replace('</a></strong>', '</a>')
    htmlId = 'paragraph-with-popover-' + miliseconds
    cssClass = 'paragraph-with-popover'
  }

  var doc = new DOMParser().parseFromString(`<div id="${htmlId}" class="${cssClass}">${text}</div>`, 'text/html')

  return createElement(doc.getElementById(htmlId), '_0')
}

const createElement = (element, key) => {
  var attributes = {}
  var children = []
  for (let i = 0; i < element.attributes.length; i++) {
    var attr = element.attributes[i]
    if (attr.name === 'class') {
      attributes['className'] = attr.value
    } else {
      attributes[attr.name] = attr.value
    }
  }

  attributes['key'] = key

  for (let i = 0; i < element.childNodes.length; i++) {
    if (element.childNodes[i].nodeName === '#text') {
      children.push(element.childNodes[i].nodeValue)
    } else {
      children.push(createElement(element.childNodes[i], i + key))
    }
  }

  if (attributes.className && attributes.className.includes('popup-text')) {
    return React.createElement(Popover, { content: attributes['data-content'], key: key }, children)
  }

  if (element.tagName.toLowerCase() === 'p') {
    return React.createElement('div', { className: 'p-style', key: attributes.key }, children)
  }

  if (element.tagName.toLowerCase() === 'math') {
    const mathAttributes = {
      mathml: `<math xmlns="http://www.w3.org/1998/Math/MathML">${element.innerHTML}</math>`,
      key: attributes.key,
      display: false
    }
    return React.createElement(MathComponent, mathAttributes, null)
  }

  if (['br', 'hr', 'img'].includes(element.tagName.toLowerCase())) {
    return React.createElement(element.tagName.toLowerCase(), attributes, null)
  }

  return React.createElement(element.tagName.toLowerCase(), attributes, children)
}

export default textAsReactComponent
